import { eTipoPermissao } from '@/enums/ePermissoes';
import {
  TIPO_ESTRUTURA_INFORMACOES_COMPLEMENTARES,
  TIPO_ESTRUTURA_INFORMACOES_PERIODICAS,
} from '@/models/educacaoinclusiva/pdiestrutura/tipo-estrutura';

// Estrutura (molde) das Informações Complementares e das Informações Periódicas.
//
// Não há tela própria: é a MESMA tela do "PDI — Estrutura", parametrizada pela rota. As três usam
// o mesmo motor de moldes (Lista/ListaEstrutura/ListaEstruturaItem/ListaSerie) e só o
// `Lista.TIPOESTRUTURA` as separa — ver `models/educacaoinclusiva/pdiestrutura/tipo-estrutura.ts`.
//
// - `meta.tipoEstrutura`: qual molde a tela administra (sem ele, 1 = PDI).
// - `meta.moldeUnico`: o molde é UM só na rede (nível/ano/ensino 0) — a tela esconde os seletores
//   de Nível/Ensino e o "Copiar de outro molde", e abre o molde direto.
//
// Ficam neste arquivo por reaproveitarem a view da Educação Inclusiva; o lugar delas no MENU vem
// do `Seg_Menu` (pai copiado do item legado 300900601/300900800), não daqui.
export default [
  {
    description: 'Estrutura das Informações Complementares',
    path: '/educacaoinclusiva/informacoescomplementares/estrutura',
    name: 'estrutura_informacoes_complementares',
    component: () => import('@/views/educacaoinclusiva/pdi-estrutura/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ESTRUTURAINFORMACOESCOMPLEMENTARESNOVO_MENU_300900699],
      tipoEstrutura: TIPO_ESTRUTURA_INFORMACOES_COMPLEMENTARES,
      moldeUnico: true,
    },
    goesToMenu: true,
  },
  {
    description: 'Estrutura das Informações Periódicas',
    path: '/educacaoinclusiva/informacoesperiodicas/estrutura',
    name: 'estrutura_informacoes_periodicas',
    component: () => import('@/views/educacaoinclusiva/pdi-estrutura/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ESTRUTURAINFORMACOESPERIODICASNOVO_MENU_300900899],
      tipoEstrutura: TIPO_ESTRUTURA_INFORMACOES_PERIODICAS,
    },
    goesToMenu: true,
  },
];
